import { AppMethodsEnum } from '../types';

export const handleCheckApplicationFormMethod = (method: string, checkValue: boolean) => {
	if (AppMethodsEnum.applicationForm === method) {
		return checkValue;
	}

	return false;
};
